import { BuildingType } from "../enums/locationTypes";
import { PermissionType } from "../enums/permissionType";
import { User } from "../interface/user";

import axios from "axios";
import * as React from "react";
import { useState } from "react";
import { useHistory } from "react-router";
import { Button, Form, Grid, Icon, Label, Modal } from "semantic-ui-react";

// TODO: #124 Replace any annotations with appropriate types
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function exampleReducer(dispatchState: any, action: any) {
  switch (action.type) {
    case "CONFIG_CLOSE_ON_DIMMER_CLICK":
      return { ...dispatchState, closeOnDimmerClick: action.value };
    case "CONFIG_CLOSE_ON_ESCAPE":
      return { ...dispatchState, closeOnEscape: action.value };
    case "OPEN_MODAL":
      return { ...dispatchState, open: true };
    case "CLOSE_MODAL":
      return { ...dispatchState, open: false };
    default:
      throw new Error();
  }
}

const buildings = Object.keys(BuildingType).map((key) => ({
  key,
  text: key,
  value: key,
}));

const actions = Object.keys(PermissionType)
  .filter((value) => value !== "ALL")
  .map((key) => ({
    key,
    text: key,
    value: key,
  }));

export default function EditPermissions(props: {
  user: User;
  // TODO: #125 Replace bad Function type with the appropriate annotation
  // eslint-disable-next-line @typescript-eslint/ban-types
  fetchUsers: Function;
}) {
  const history = useHistory();
  const [permissions, setPermissions] = useState<string[]>(
    props.user.permissions
  );
  const [building, setBuilding] = useState<string>("");
  const [action, setAction] = useState<string>("");
  const [dispatchState, dispatch] = React.useReducer(exampleReducer, {
    closeOnEscape: false,
    closeOnDimmerClick: false,
    open: false,
    dimmer: undefined,
  });
  const { open, closeOnEscape, closeOnDimmerClick } = dispatchState;

  return (
    <Grid columns={1}>
      <Grid.Column>
        <Modal
          closeOnEscape={closeOnEscape}
          closeOnDimmerClick={closeOnDimmerClick}
          open={open}
          onOpen={() => dispatch({ type: "OPEN_MODAL" })}
          onClose={() => dispatch({ type: "CLOSE_MODAL" })}
          trigger={
            <Button icon circular color="blue" size="tiny">
              <Icon name="edit outline" inverted size="large"></Icon>
            </Button>
          }
        >
          <Modal.Header>Edit Permissions</Modal.Header>
          <Modal.Content>
            {/* Need to stop modal from closing when enter key is pressed */}
            <Form
              onSubmit={() => {
                setPermissions([...permissions, `${building}:${action}`]);
                setBuilding("");
                setAction("");
              }}
            >
              <h3>Permissions</h3>
              {permissions.map((perm, index) => {
                const [building, action] = perm.split(":");
                /* users = blue, admin all = yellow, other admin = green */
                const color =
                  action !== PermissionType.ADMIN
                    ? "blue"
                    : building !== BuildingType.ALL
                    ? "green"
                    : "yellow";
                return (
                  <Label
                    color={color}
                    image
                    key={index}
                    as="a"
                    onClick={() => {
                      setPermissions(
                        permissions.filter((_value, idx) => idx !== index)
                      );
                    }}
                  >
                    {building}
                    <Label.Detail>
                      {action}
                      <Icon name="delete" />
                    </Label.Detail>
                  </Label>
                );
              })}
              <h3>Add Specific Permission</h3>
              <Form.Group widths="equal">
                <Form.Select
                  fluid
                  required
                  options={buildings}
                  placeholder="Building"
                  name="building"
                  value={building}
                  onChange={(_e, { value }) => {
                    setBuilding(String(value));
                  }}
                />
                <Form.Select
                  fluid
                  required
                  options={actions}
                  placeholder="Action"
                  name="action"
                  value={action}
                  onChange={(_e, { value }) => {
                    setAction(String(value));
                  }}
                />
                <Form.Button color="teal">Add Permission</Form.Button>
              </Form.Group>
              <Form.Group inline id="modal-actions">
                <Button
                  color="red"
                  onClick={() => dispatch({ type: "CLOSE_MODAL" })}
                >
                  Cancel
                </Button>
                <Button
                  positive
                  style={{ marginLeft: "10px" }}
                  onClick={() => {
                    axios
                      .post("/api/accounts/updatePerm", {
                        token: localStorage.getItem("lnf_token"),
                        username: props.user.username,
                        perm: permissions,
                      })
                      .then(
                        (res) => {
                          console.log("Edited permissions!");
                          console.log(res);
                          props.fetchUsers();
                          dispatch({ type: "CLOSE_MODAL" });
                        },
                        (error) => {
                          console.log(error);
                          alert("Unable to edit permissions");
                          if (error?.response?.status === 401) {
                            window.localStorage.removeItem("lnf_token");
                            history.push("/login");
                          }
                          dispatch({ type: "CLOSE_MODAL" });
                        }
                      );
                  }}
                >
                  Edit
                </Button>
              </Form.Group>
            </Form>
          </Modal.Content>
        </Modal>
      </Grid.Column>
    </Grid>
  );
}
